import React from 'react';
import concorde from '../../imgs/concorde.png';

export default class Plane2 extends React.Component {
  render() {
    return (
      <div className='typography-container'>
        <h1>Сверхзвуковая гражданская авиация</h1>
        <p>
        Конструкторы начали мечтать о сверхбыстрых и комфортабельных пассажирских
        перелетах в 1950-х годах. Это было время, когда боевой авиации стали
        доступны полеты на сверхзвуковой скорости, а развитие реактивных двигателей
        шло очень быстро. Реализовать проект гражданского сверхзвукового самолета
        удалось в 1970-х, когда начали полеты советский Ту-144 и французский
        Concorde.
        </p>
        <p align='center'>
          <img src={concorde}/>
        </p>
        <p>
        Казалось, что за подобными разработками будущее, но других сверхзвуковых
        лайнеров построено так и не было. Ту-144 на пассажирских маршрутах
        использовали в общей сложности меньше года; Concorde эксплуатировался до
        2003 года, но им пользовались лишь несколько авиакомпаний. Причина неудачи
        программы Ту-144 и Concorde одна и та же — дороговизна.
        </p>
        <p>
        Однако, в последние годы сразу несколько компаний по всему миру начали
        разрабатывать новые сверхзвуковые пассажирские самолеты. Сторонники
        перемещения по воздуху со скоростью выше 1200 километров в час уверены, что
        добраться из Нью-Йорка в Лондон можно будет за три-четыре часа всего за
        несколько тысяч долларов — по цене билета в бизнес-классе в обычном
        лайнере. Правда, у сверхзвуковых самолетов по-прежнему остаются серьезные
        ограничения — и по шуму, и по экономичности.
        </p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/docs/Plane-2.js